import { Component, OnInit } from '@angular/core';
import {OrganisationPreferencesService} from '../../../../_services/organisation/organisation-preferences.service';

@Component({
  selector: 'acabim-admin-onboarding-building-assets-auto-generate',
  templateUrl: './onboarding-building-assets-auto-generate.component.html',
  styleUrls: ['../styles.scss', './onboarding-building-assets-auto-generate.component.scss']
})
export class OnboardingBuildingAssetsAutoGenerateComponent implements OnInit {

  isLoading = false;
  active = false;

  constructor(
      private readonly organisationPreferencesService: OrganisationPreferencesService
  ) { }

  ngOnInit(): void {
    this.getPreferences();
  }

  getPreferences(): void {
    this.isLoading = true;
    this.organisationPreferencesService.getPreferences().subscribe(data => {
      if (data) {
        this.active = data.run_generate_assets_task;
        this.isLoading = false;
      }
    });
  }

  submit(value: boolean) {
    this.organisationPreferencesService.updatePreference('run_generate_assets_task', value).subscribe(res => {
      this.getPreferences();
    });
  }

} // EOC
